import { ReactElement, ReactNode } from 'react';
import cx from 'clsx';
import { Box, Sprinkles } from '@ff-it/ui';
import * as style from './style.css';

type TitleContainerProps = {
  className?: string;
  testId?: string;
  title?: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
  htmlTitle?: string;
  disabled?: boolean;
  flat?: boolean;
  style?: React.CSSProperties;
} & Sprinkles;

export function TitleContainer({
  title,
  subtitle,
  children,
  className,
  testId,
  htmlTitle,
  flat,
  disabled,
  ...rest
}: TitleContainerProps): ReactElement {
  return (
    <Box
      className={cx(style.container, className, flat ? style.flat : undefined, disabled ? style.disabled : undefined)}
      data-testid={testId}
      title={htmlTitle}
      {...rest}
    >
      {title && <Title>{title}</Title>}
      {subtitle && <SubTitle>{subtitle}</SubTitle>}
      {children}
    </Box>
  );
}

type TitleProps = {
  className?: string;
  children: ReactNode;
  testId?: string;
};

export function Title({ children, className, testId = 'title' }: TitleProps): ReactElement {
  return (
    <Box data-testid={testId} className={cx(style.title, className)}>
      {children}
    </Box>
  );
}

export function SubTitle({ children, className, testId = 'subtitle' }: TitleProps): ReactElement {
  return (
    <Box data-testid={testId} className={cx(style.subtitle, className)}>
      {children}
    </Box>
  );
}
